<template>
  <f-modal
    ref="day-popup-modal"
    :class="{ 'is-visible': isVisible }"
    @close="handleClose">
    <f-modal-header>
      <h3 class="heading-medium">
        {{ $t('calendar.meetingsOn') }}: <span class="text-nowrap">{{ popupTitle }}</span>
      </h3>
    </f-modal-header>

    <f-modal-body>
      <f-list
        ref="meetings-list"
        class="calendar-day-list"
        :listSettings="meetingsListSettings"
        :listItems="meetingsFormatted"
        :isPlain="true"
        :itemAction="showEditPopup"
        :data-mobile-actions-count="1"
        :loaded="loaded" />

    </f-modal-body>
    <f-modal-footer>
      <div class="flex flex-justify-content-between">
        <f-button
          class="ml-0"
          theme="danger"
          @click.prevent="handleClose">
          {{ $t('ui.close') }}
        </f-button>
        <f-button
          class="ml-auto"
          theme="primary"
          :disabled="!isAddMeetingAvailable"
          @click.prevent="addMeetingToday(currentDate)">
          {{ $t('calendar.addMeetings') }}
        </f-button>
      </div>
    </f-modal-footer>
  </f-modal>
</template>
<script>
import ListUtils from '@/utils/ListUtils.js';

export default {
  name: 'calendar-day-popup',
  computed: {
    popupTitle () {
      return this.currentDate;
    },
    meetingsFormatted () {
      let meetingsList = this.currentDayMeetings;

      return meetingsList.map((item) => {
        item.start_at = item.start_date;

        if (item.start_time) {
          let startAtFormatted = item.start_time.split(':');
          startAtFormatted.pop();
          item.start_at = item.start_at.concat(', ', (startAtFormatted.join(':')));
        }

        item.end_at = item.end_date;

        if (item.end_time) {
          let endAtFormatted = item.end_time.split(':');
          endAtFormatted.pop();
          item.end_at = item.end_at.concat(', ', (endAtFormatted.join(':')));
        }

        item.all_day_long = item.all_day ? 'Tak' : 'Nie';

        item.actionsList = ['edit', 'delete'];

        return item;
      });
    },
    isAddMeetingAvailable () {
      let popupDate = new Date(this.currentDate);
      let nowDate = new Date();

      if (popupDate.getFullYear() > nowDate.getFullYear()) {
        return true;
      }

      if ((popupDate.getFullYear() === nowDate.getFullYear()) && (popupDate.getMonth() > nowDate.getMonth())) {
        return true;
      }

      if ((popupDate.getFullYear() === nowDate.getFullYear()) && (popupDate.getMonth() === nowDate.getMonth())) {
        if (popupDate.getDate() >= nowDate.getDate()) {
          return true;
        }
      }

      return false;
    }
  },
  data() {
    return {
      currentDate: '',
      currentDayMeetings: [],
      isVisible: false,
      removeInProgress: false,
      meetingsListSettings: [
        {
          title: this.$t('calendar.commencement'),
          variableName: ['start_at'],
          type: 'String'
        },
        {
          title: this.$t('calendar.completion'),
          variableName: ['end_at'],
          type: 'String'
        },
        {
          title: this.$t('calendar.allSayEvent'),
          variableName: ['all_day_long'],
          type: 'String'
        },
        {
          title: '',
          variableName: ['actionsList'],
          type: 'actions',
          items: [
            {
              type: 'button',
              disabled: false,
              event: 'meeting-edit',
              label: this.$t('ui.open'),
              name: 'edit'
            },
            {
              type: 'button',
              disabled: false,
              event: 'meeting-remove',
              label: this.$t('ui.remove'),
              theme: 'danger',
              name: 'delete'
            }
          ]
        }
      ],
      loaded: false
    };
  },
  mounted() {
    this.$bus.$on('show-calendar-day-popup', this.openPopup);
    this.$bus.$on('meeting-edit', this.showEditPopup);
    this.$bus.$on('meeting-remove', this.removeMeeting);
    this.loaded = true;
  },
  methods: {
    handleClose() {
      document.body.classList.remove('no-scroll');
      this.isVisible = false;
    },
    openPopup(date, allMeetings) {
      this.currentDate = date;

      this.currentDayMeetings = allMeetings.filter(meeting => meeting.start_date <= date && meeting.end_date >= date);
      this.currentDayMeetings.sort((a, b) => ((new Date('1970/01/01 ' + a.time)) - (new Date('1970/01/01 ' + b.time))));

      setTimeout(() => {
        this.isVisible = true;
        document.body.classList.add('no-scroll');
      }, 0);
    },
    showEditPopup (meeting) {
      this.$bus.$emit('calendar-add-meeting-popup-show', meeting);
    },
    removeMeeting (itemToRemove) {
      this.removeInProgress = true;
      let meetingId = typeof itemToRemove === 'object' ? itemToRemove.id : itemToRemove;

      ListUtils.removeItem(this, {
        endpointBase: '/api/adviser/meetings/delete/',
        id: meetingId,
        successTitle: this.$t('calendar.deletedMeeting'),
        successText: this.$t('calendar.selectedMeetingHasBeenRemove'),
        confirmTitle: this.$t('calendar.areYouSureToRemoveMeeting'),
        confirmText: this.$t('ui.thisOperationCannotUndone'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('calendar.removeMeetingError'),
        successAction: () => {
          this.currentDayMeetings = this.currentDayMeetings.filter(meeting => meeting.id !== meetingId);
          this.removeInProgress = false;
          this.$bus.$emit('calendar-refresh');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    addMeetingToday () {
      this.handleClose();
      this.$bus.$emit('calendar-add-meeting-popup-show', null, this.currentDate)
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-calendar-day-popup', this.openPopup);
    this.$bus.$off('meeting-edit', this.showEditPopup);
    this.$bus.$off('meeting-remove', this.removeMeeting);
  }
}
</script>
